import { Component, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';

declare  var jQuery:  any;
declare  var load_rev_slider_1:  any;

@Component({
    selector: 'app-section-slider',
    templateUrl: './section-slider1.component.html',
    styleUrls: ['./section-slider1.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SectionSlider1Component implements AfterViewInit {

  constructor() { }

  ngAfterViewInit(): void {
    (function ($) {
      setTimeout(function(){
        load_rev_slider_1();
        }, 100);
      })(jQuery);
    }
}
